import { render, staticRenderFns } from "./DesktopSubmenu.vue?vue&type=template&id=5590aa7e&scoped=true&"
import script from "./DesktopSubmenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./DesktopSubmenu.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DesktopSubmenu.vue?vue&type=style&index=0&id=5590aa7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5590aa7e",
  null
  
)

export default component.exports